<gl-base-modal [disableCloseButton]="false" class="completeModal" (closeModal)="closeModal()">
<div class="contentContainer">
  {{ 'complete_address' | translate }}
</div>
  <div class="multiStopContainer">
    <gl-multi-stop-edit
      [position]="getPosition()"
      [currentWorkSpaceId]="currentWorkSpaceId"
      [isComplete]="true"
      [savedStops]="savedStops"
      (submitStops)="submitStops($event)"
      class="multiStopComponent"
    ></gl-multi-stop-edit>
  </div>
</gl-base-modal>
